export let hideFooter = true;

export const setHideFooter = (val: boolean) => {
  hideFooter = val
}